import {
  AfterViewInit,
  Component,
  computed,
  effect,
  ElementRef,
  inject,
  Signal,
  ViewChild
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterOutlet
} from '@angular/router';
import { LanguageService } from '../../shared/services/language.service';
import { TranslatePipe } from '../../shared/pipes/translate.pipe';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { StepperService } from '../../shared/services/stepper.service';
import { StepperComponent } from '../../view/stepper/stepper.component';
import { ReferenceStateService } from '../../shared/services/state/reference-state.service';
import { filter, shareReplay, take } from 'rxjs';
import { AuthStateService } from '../../shared/services/state/auth-state.service';
import { AuthFeatureService } from '../../shared/services/feature/auth.feature.service';
import { IAcsHttpService } from '../../shared/services/http/acs/acs-http-service.interface';
import { ACS_HTTP_SERVICE } from '../../shared/services/http/http-service.token';
import { SubscriptionFeatureService } from '../../shared/services/feature/subscription-feature.service';
import { SouscriptionComponentService } from '../../shared/services/component/souscription-component.service';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    StepperComponent,
    MatIconModule,
    TranslatePipe
  ],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent implements AfterViewInit {
  @ViewChild('scrollableContainer')
  scrollableContainer!: ElementRef<HTMLDivElement>;
  isScrolled = false;

  private stepperService: StepperService = inject(StepperService);
  readonly acsHttpService: IAcsHttpService = inject(ACS_HTTP_SERVICE);
  private referenceStateService: ReferenceStateService = inject(
    ReferenceStateService
  );
  private authStateService: AuthStateService = inject(AuthStateService);
  private authFeatureService: AuthFeatureService = inject(AuthFeatureService);
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private subscriptionFeatureService: SubscriptionFeatureService = inject(
    SubscriptionFeatureService
  );
  private souscriptionComponentService: SouscriptionComponentService = inject(
    SouscriptionComponentService
  );

  protected showStepper: Signal<boolean> = computed(() =>
    this.stepperService.isVisible()
  );

  protected isGlobalLoading: Signal<boolean> = computed(
    () =>
      this.subscriptionFeatureService.isLoading() ||
      this.souscriptionComponentService.selectIsLoading()()
  );

  constructor() {
    inject(LanguageService).initialiseLanguages().subscribe();
    this.router.events
      .pipe(
        filter((evt) => evt instanceof NavigationEnd),
        take(1)
      )
      .subscribe(() =>
        this.authFeatureService.initializeAuthentication(
          this.route.snapshot.queryParamMap
        )
      );

    this.router.events
      .pipe(
        filter((evt) => evt instanceof NavigationEnd),
        takeUntilDestroyed()
      )
      .subscribe(() => this.scrollableContainer?.nativeElement.scrollTo(0, 0));

    effect(() => {
      if (this.authStateService.selectInitStatusState()() === 'DONE') {
        this.acsHttpService
          .getCustomList()
          .pipe(shareReplay(1))
          .subscribe((value) => this.referenceStateService.updateData(value));
      }
    });
  }

  ngAfterViewInit() {
    this.scrollableContainer.nativeElement.addEventListener('scroll', () => {
      this.isScrolled = this.scrollableContainer.nativeElement.scrollTop > 0;
    });
  }
}
